<template>
  <div class="FilterBox">
    <div class="selectTop flexContainer">
      <div class="flexItem1 selectTopItem">
        城市
        <i class="iconfont_new icon-caretdown down"></i>
      </div>
      <div class="flexItem1 selectTopItem" v-bind:class="{ selectTopItemActive: selectArea }" @click="selectArea=!selectArea;selectStar=false;">
        行政区
        <i class="iconfont_new icon-caretdown down"></i>
      </div>
      <div class="flexItem1 selectTopItem" v-bind:class="{ selectTopItemActive: selectStar }" @click="selectStar=!selectStar;selectArea=false;">
        星级
        <i class="iconfont_new icon-caretdown down"></i>
      </div>
    </div>

    <div class="selectTopDiv" v-if="selectArea">
      <div class="selectTopScrollDiv">
        <div class="selectTopTitle">行政区</div>

        <Row :gutter="10">
          <Col span="6" v-for="(data,key) in area_list" :key="key">
            <div
              class="item"
              v-bind:class="{ itemActive: data.check }"
              @click="check('area_list',key)"
            >
              {{data.name}}
              <i class="iconfont_new icon-Checkout selectCheck"></i>
            </div>
          </Col>
        </Row>
      </div>

      <div class="selectBtn flexContainer">
        <div class="flexItem1">
          <Button long size="small" @click="reset('area_list')">重置</Button>
        </div>
        <div class="flexItem1">
          <Button long size="small" type="warning" @click="selectOk('area_list')">确定</Button>
        </div>
      </div>
    </div>

    <div class="selectTopDiv" v-if="selectStar">
      <div class="selectTopTitle">星级</div>
      <div class="flexContainer">
        <div
          class="flexItem1 item"
          v-for="(data,key) in star_list"
          :key="key"
          v-bind:class="{ itemActive: data.check }"
          @click="check('star_list',key)"
        >
          {{data.name}}
          <div>{{data.text}}</div>
          <i class="iconfont_new icon-Checkout selectCheck"></i>
        </div>
      </div>
      <div class="selectBtn flexContainer">
        <div class="flexItem1">
          <Button long size="small" @click="reset('star_list')">重置</Button>
        </div>
        <div class="flexItem1">
          <Button long size="small" type="warning" @click="selectOk('star_list')">确定</Button>
        </div>
      </div>
    </div>

    <div
      class="selectLayer"
      v-if="selectArea || selectStar"
      @click="selectArea=false;selectStar=false;"
    ></div>
  </div>
</template>

<script>
export default {
  name: "DropdownFilter",
  props: {
    areaList: {
      type: Array,
      default: [],
      required: false,
    },
    starList: {
      type: Array,
      default: [],
      required: false,
    },
  },
  data() {
    return {
      selectArea: false, //行政区筛选框
      // areaList: [
      //   { name: "石歧", check: false },
      //   { name: "东区", check: false },
      // ],

      selectStar: false, //星级筛选框
      // starList: [
      //   { name: "二钻(星)及以下", text: "经济", check: false },
      //   { name: "三钻(星)", text: "舒适", check: false },
      //   { name: "四钻(星)", text: "高档", check: false },
      //   { name: "五钻(星)", text: "豪华", check: false },
      // ],
    };
  },
  activated: function () {},
  created() {},
  mounted() {},
  computed: {
    area_list: function () {
      return this.areaList;
    },
    star_list: function () {
      return this.starList;
    },
  },
  methods: {
    //点击选项：
    check(listName, key) {
      for (let i = 0; i < this[listName].length; i++) {
        if (key == i) {
          this[listName][i].check = !this[listName][i].check;
          this.$forceUpdate();
        }
      }
    },
    //重置：
    reset(listName) {
      for (let i = 0; i < this[listName].length; i++) {
        this[listName][i].check = false;
        this.$forceUpdate();
      }
    },
    selectOk(listName) {
      if (listName == "area_list") {
        this.$emit("selectOk", "areaList", this[listName]);
      }
      if (listName == "star_list") {
        this.$emit("selectOk", "starList", this[listName]);
      }
    },
  },
};
</script>

<style scoped lang="less">
@import "../../style/home.less";
</style>



// WEBPACK FOOTER //
// src/components/child-components/DropdownFilter.vue